// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eMatchReportEditor .quillEditor-root {
  width: 100%;
}

.eMatchReportEditor .quillEditor-root .ql-editor {
  min-height: 28em;
}

.eMatchReportEditor .gmQuillToolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 6px;
}

.eMatchReportEditor .gmQuillToolbar .ql-formats {
  flex: 0 0 auto;
}

.eMatchReportEditor .mDisabled .ql-editor {
  background-color: #e9ecef;
  color: #495057;
}
`, "",{"version":3,"sources":["webpack://./src/components/HTMLEditorQuill/HTMLEditorQuillForMatchReport.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".eMatchReportEditor .quillEditor-root {\n  width: 100%;\n}\n\n.eMatchReportEditor .quillEditor-root .ql-editor {\n  min-height: 28em;\n}\n\n.eMatchReportEditor .gmQuillToolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding-bottom: 6px;\n}\n\n.eMatchReportEditor .gmQuillToolbar .ql-formats {\n  flex: 0 0 auto;\n}\n\n.eMatchReportEditor .mDisabled .ql-editor {\n  background-color: #e9ecef;\n  color: #495057;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
